import { render, staticRenderFns } from "./ActionsCreatePage.vue?vue&type=template&id=b5958234&"
import script from "./ActionsCreatePage.vue?vue&type=script&lang=js&"
export * from "./ActionsCreatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports